$(function () {
	let a_tag = $('.a_tag').attr('href');
	if (a_tag == "") {
		$('.a_tag').css('pointer-events', 'none');
	}
});
